module.exports = __webpack_public_path__ + "staticcomp/img/cover.77ae7b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/13/cover.jpg
// module id = g+ou
// module chunks = 39